import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class StatistiqueService {

  constructor(
    private http: HttpClient,
    private messageService: MessageService
  ) { }

  obtenirStatistiquesDashboard(): Observable<any> {
    const url = `${environment.apiurl}statistiques/dashboard`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  /** Évolution sur les N derniers jours (sparklines). */
  obtenirEvolution(jours: number = 30): Observable<any[]> {
    const url = `${environment.apiurl}statistiques/evolution?jours=${jours}`;
    return this.http.get<any[]>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirLivraisonsEnAttente(): Observable<any[]> {
    const url = `${environment.apiurl}statistiques/livraisons-en-attente`;
    return this.http.get<any[]>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirActivitesRecentes(): Observable<any[]> {
    const url = `${environment.apiurl}statistiques/activites-recentes`;
    return this.http.get<any[]>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirDashboardGlobalAdmin(): Observable<any> {
    const url = `${environment.apiurl}statistiques/dashboard-global`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirTableauBordPartenairesTransport(): Observable<any> {
    const url = `${environment.apiurl}vehicules/partenaires/tableau-bord`;
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  /** Tableau de bord interurbain complet (admin) : pipeline, encaissements, délais, top trajets */
  obtenirDashboardInterurbain(debut?: string, fin?: string): Observable<any> {
    let url = `${environment.apiurl}statistiques/interurbain`;
    const params: string[] = [];
    if (debut) params.push(`debut=${encodeURIComponent(debut)}`);
    if (fin) params.push(`fin=${encodeURIComponent(fin)}`);
    if (params.length) url += '?' + params.join('&');
    return this.http.get<any>(url).pipe(catchError(this.messageService.gererErreur));
  }

  /** Tableau de bord personnalisé du gestionnaire de zone connecté */
  obtenirDashboardZoneManager(): Observable<any> {
    const url = `${environment.apiurl}statistiques/zone-manager/moi`;
    return this.http.get<any>(url).pipe(catchError(this.messageService.gererErreur));
  }

  /** Valide ou invalide un encaissement (admin/gestionnaire) */
  validerEncaissement(commandeId: number, valide: boolean): Observable<any> {
    const url = `${environment.apiurl}commandes/${commandeId}/valider-encaissement?valide=${valide}`;
    return this.http.put<any>(url, {}).pipe(catchError(this.messageService.gererErreur));
  }

  obtenirDashboardComptabiliteGlobal(params = ''): Observable<any> {
    return this.http.get<any>(`${environment.apiurl}statistiques/comptabilite/global${params}`).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirDashboardComptabiliteZone(params = ''): Observable<any> {
    return this.http.get<any>(`${environment.apiurl}statistiques/comptabilite/zone-moi${params}`).pipe(
      catchError(this.messageService.gererErreur)
    );
  }
}
